import { render, staticRenderFns } from "./NewsSubscribe.vue?vue&type=template&id=16e5e39c&lang=pug&"
import script from "./NewsSubscribe.vue?vue&type=script&lang=js&"
export * from "./NewsSubscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports